import Vue from 'vue';

export default {

  SET_SHOW_SCROLL_TO_NEW_MESSAGES_BUTTON: (state, payload) => {
    state.showScrollToNewMessagesButton = payload;
  },
  
  SET_NEW_MESSAGES_COUNT: (state, payload) => {
    state.newMessagesCount = payload;
  },
  
  SET_CHAT_FILTER: (state, payload) => {
    Vue.set(state.filters, payload.compId, payload.val);
  },
  
  SET_CHAT_FILTER_DIALOG: (state, payload) => {
    Vue.set(state.chatFilterDialogs, payload.compId, payload.val);
  },

  CLEAR_CHAT_MESSAGES: (state) => {
    // Clear all chat messages from the store
    if (state.entities && state.entities.chatMessages) {
      state.entities.chatMessages = {};
    }
  },

};


// WEBPACK FOOTER //
// ./src/store/chats/mutations.js